"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledActionButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _button = require("../../button");
const StyledActionButton = (0, _styled.default)(_button.Button)`
    height: 32px;
    color: ${(0, _designTokensReact.color)("color--text--neutral--strong")};
`;
exports.StyledActionButton = StyledActionButton;
//# sourceMappingURL=ActionButton.js.map